import React from 'react';

import ListDepartment from "./department-list";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import './User.scss';

const Department = () => {
  return (
    <>
      <Navbar />
      <div className="min-h-full flex justify-center items-center campain-table-container container">
        <div className="table-wrapper w-full">
          <div className="campain-title">
            <h2 className="text-center mt-3">Department</h2>
          </div>
          <ListDepartment />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Department;
